import {ExternalAppEventDispatch} from '@core/models/external-app-event-dispatch';
import {take, takeUntil} from 'rxjs/operators';
import {ItpDesktopService} from '@core/services/itpdesktopservices/itp-desktop.service';
import {Subject} from 'rxjs';
import {ItpDesktopUtilityService} from '@core/services/itpdesktopservices/itp-desktop-utility.service';
import {Injectable} from '@angular/core';
import {PlatformCommand} from '@shared/commands/command-base';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {FileManagementService} from '@core/services/file-management.service';
import {Router} from '@angular/router';
import {FuseSidebarService} from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import {
  SetCurrentRightSideBarFoldOrNotAction,
  SetCurrentRightSideComponentAction
} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {Store} from '@ngrx/store';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';

@Injectable()
export class ItpDesktopEventDispatchService extends ExternalAppEventDispatch {
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private itpDesktopService: ItpDesktopService,
    private itpDesktopUtilityService: ItpDesktopUtilityService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private commandService: CommandService,
    private fileManagementService: FileManagementService,
    private sidebarService: FuseSidebarService,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private router: Router,
  ) {
    super('ItpDesktopService', document.cookie.includes('isDesktop'));

    if (/*true ||*/ this.itpDesktopService.isDesktop()) {
      this.externalAppEventNotification.pipe(takeUntil(this.ngUnsubscribe)).subscribe((payload: any) => {
        this.eventdispatcher(payload);
      });
    }
  }

  eventdispatcher(event: any) {
    switch (event.type) {
      case 'entitySelectedInDesigner':
        this.itpDesktopUtilityService.entitySelectedInDesigner(event.payload);
        break;
      case 'openCalculator':
        this.itpDesktopUtilityService.openCalculator(event.payload);
        break;
      case 'closeCalculator':
        this.itpDesktopUtilityService.closeCalculator(event.payload);
        break;
      case 'startEatExecution':
        this.itpDesktopUtilityService.startEatExecution(event.payload);
        break;
      case 'executeMarkAsComplete':
        this.itpDesktopUtilityService.executeMarkAsComplete(event.payload);
        break;
      case 'addRemoveEntities':
        this.itpDesktopUtilityService.executeAddRemoveEntity(event.payload);
        break;
      case 'filterSlide':
        this.itpDesktopUtilityService.filterSlide();
        break;
      case 'filterExplorer':
        this.itpDesktopUtilityService.filterExplorer();
        break;
      case 'redirectBreadcrumbUrl':
        this.itpDesktopUtilityService.redirectBreadcrumbUrl(event.payload);
        break;
      case 'command':
        this.executeCommandApi(event.payload);
        break;
      case 'openScenarioDetails':
        this.itpDesktopUtilityService.openScenarioDetails(event.payload);
        break;
      case 'onStayIn':
        this.itpDesktopUtilityService.onStayIn();
        break;
      case 'collapseRightSidePanel':
        this.itpDesktopUtilityService.collapseRightSidePanel(event.payload);
        break;
    }
  }

  executeCommandApi(command: PlatformCommand) {
    console.log('[DesktopEventDispatch] Executing PlatformCommand : ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      const commandName = command.name;
      const fieldValues = command.fieldValues;

      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[DesktopEventDispatch] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();

          if (commandName === 'DownloadAsZipCommand') {
            this.fileManagementService.downloadClientFileWithId(commandResponse.fieldValues.Payload.fileId).pipe().subscribe((payload: any) => {
              this.fuseSplashScreenService.hide();
              this.fileManagementService.openSaveFileWindow(payload, commandResponse.fieldValues.Payload.fileName);
            }, (error) => this.fuseSplashScreenService.hide());
          }

          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommandApi(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
        },
        error => {
          console.error('[DesktopEventDispatch] Failed command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }
}
